// src/utils/counterService.js
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';

export const getNextSharedId = async () => {
  const counterDocRef = doc(db, 'counters', 'sharedCounter');
  const counterDoc = await getDoc(counterDocRef);

  if (counterDoc.exists()) {
    const currentCounter = counterDoc.data().count;
    await updateDoc(counterDocRef, { count: currentCounter + 1 });
    return currentCounter + 1;
  } else {
    // Si el contador no existe, inicialízalo
    await setDoc(counterDocRef, { count: 1 });
    return 1;
  }
};
